import { Paso } from './Paso';

export class PasoMonitor extends Paso {
  constructor() {
    super(
      false,
      'Monitor',
      'El monitor es fundamental si querés disfrutar de tus juegos y peliculas favoritas',
      9,
      'monitor.png',
      'monitor.png',
      true,
      [],
      '',
    );
  }
}
